export default __webpack_public_path__ + "static/media/general-reception-custom-sample.32b0ea36.png";